import { observable, action, computed, createTransformer, reaction } from "mobx";
import PagamentosService from "../../../services/PagamentosService";

export default class PagamentosPendentesStore {

    @observable pagamentos;
    @observable loading;

    constructor() {
        this.pagamentos = [];
        this.pagamentoService = new PagamentosService()
    }

    carregarLista() {
        this.loading = true;

        const loadingPromises = Promise.all([
            this.pagamentoService.listarPagamentosPendentes().then(response => {
                this.pagamentos = response.data;
            }).catch(error => {
                console.log(error);
            })
        ]);
        loadingPromises.then(
            () => {
                this.loading = false;
            }
        ).catch(
            (error) => this.loading = false
        )
    }

    setLista(value) {
        this.pagamentos = value;
    }







}